import { createIcon } from '../utils';

export const AngularityIcon = createIcon({
  displayName: 'AngularityIcon',
  viewBox: '0 0 20 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m15.375 5.86 1.06 1.06-9.719 9.72h10.19v1.5H3.094l12.28-12.28Z"
    />
  ),
});

export const CenterlineIcon = createIcon({
  displayName: 'CenterlineIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.607 15.546v3h7.907v-1.7H8.582V15.72a4.207 4.207 0 0 0 1.507-.406 3.567 3.567 0 0 0 1.387-1.176 3.614 3.614 0 0 0 .62-1.7h-1.86c-.08.354-.223.656-.428.908-.2.251-.45.445-.748.581-.15.068-.31.118-.478.151V7.253c.379.07.696.221.951.456.367.332.601.728.703 1.189h1.86a3.476 3.476 0 0 0-.645-1.733 3.577 3.577 0 0 0-1.413-1.15 4.35 4.35 0 0 0-1.456-.39v-.17H6.607V5.8a3.998 3.998 0 0 0-.973.444c-.682.43-1.21 1.03-1.585 1.796-.375.763-.563 1.643-.563 2.64 0 .985.184 1.858.55 2.62.367.764.89 1.362 1.572 1.797.307.192.64.342 1 .448Zm0-1.89V7.682c-.363.274-.65.654-.858 1.139-.221.511-.332 1.116-.332 1.815 0 .716.108 1.334.326 1.854.207.495.495.884.864 1.166Z"
    />
  ),
});

export const CircularRunoutIcon = createIcon({
  displayName: 'CircularRunoutIcon',
  viewBox: '0 0 23 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6931 5.35983H18.314V9.9808H16.814V7.92049L6.09435 18.6402L5.03369 17.5795L15.7534 6.85983H13.6931V5.35983Z"
    />
  ),
});

export const CircularityIcon = createIcon({
  displayName: 'CircularityIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75Z"
    />
  ),
});

export const ConcentricityIcon = createIcon({
  displayName: 'ConcentricityIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.943 3.25c4.806 0 8.694 3.923 8.694 8.75s-3.888 8.75-8.694 8.75c-4.806 0-8.693-3.923-8.693-8.75s3.887-8.75 8.693-8.75Zm0 1.5C7.976 4.75 4.75 7.99 4.75 12s3.226 7.25 7.193 7.25c3.968 0 7.194-3.241 7.194-7.25s-3.226-7.25-7.194-7.25Zm.022 1.5c3.16 0 5.714 2.58 5.714 5.75s-2.553 5.75-5.714 5.75c-3.161 0-5.715-2.58-5.715-5.75s2.554-5.75 5.715-5.75Zm0 1.5C9.642 7.75 7.75 9.648 7.75 12c0 2.352 1.892 4.25 4.215 4.25 2.322 0 4.214-1.898 4.214-4.25 0-2.352-1.892-4.25-4.214-4.25Z"
    />
  ),
});

export const ContinuousFeatureIcon = createIcon({
  displayName: 'ContinuousFeatureIcon',
  viewBox: '0 0 36 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.95 10.11h1.33a3.586 3.586 0 0 0-.426-1.248 3.188 3.188 0 0 0-.797-.929 3.419 3.419 0 0 0-1.087-.58c-.4-.133-.832-.2-1.295-.2-.753 0-1.425.18-2.016.542-.59.358-1.057.872-1.398 1.542-.34.668-.511 1.467-.511 2.4 0 .928.169 1.728.507 2.399.341.67.807 1.186 1.398 1.546.59.358 1.264.537 2.02.537.48 0 .923-.07 1.33-.213a3.528 3.528 0 0 0 1.082-.6 3.29 3.29 0 0 0 .78-.93c.204-.36.342-.755.413-1.184l-1.33-.005a2.04 2.04 0 0 1-.805 1.283c-.202.148-.428.26-.678.337-.247.074-.508.11-.784.11a2.47 2.47 0 0 1-1.342-.374c-.398-.25-.712-.62-.942-1.108-.227-.489-.34-1.088-.34-1.799 0-.704.113-1.3.34-1.79.23-.488.543-.859.938-1.112a2.468 2.468 0 0 1 1.35-.379c.279 0 .542.038.789.115.25.077.476.19.677.341a2.034 2.034 0 0 1 .797 1.3Zm2.905-2.837V16h1.317v-3.805h3.708v-1.13h-3.708V8.406h4.095V7.273h-5.412Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.986 22 2 12 8.986 2h18.028L34 12l-6.986 10H8.986Zm17.246-1.5H9.768L3.83 12l5.938-8.5h16.464L32.17 12l-5.938 8.5Z"
      />
    </>
  ),
});

export const CountIcon = createIcon({
  displayName: 'CountIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M16.103 13.7636L13.3521 9.5354H15.1416L16.9978 12.3883L18.8539 9.5354H20.6434L17.8926 13.7636L20.6844 18.0547H18.8949L16.9978 15.1389L15.1008 18.0547H13.3113L16.103 13.7636Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M7.22204 7.48666C6.10128 7.52261 5.07861 8.28654 5.07861 9.63973V9.85777H3.57861V9.63973C3.57861 7.3068 5.42531 6.04353 7.17394 5.98743C8.05339 5.95921 8.96657 6.22628 9.66885 6.85027C10.3845 7.48611 10.8174 8.43633 10.8174 9.63973C10.8174 10.6534 10.2757 11.6632 9.6205 12.5375C8.94848 13.4343 8.06821 14.3043 7.21173 15.0566C6.68827 15.5164 6.16597 15.9388 5.69298 16.304H11.0223V17.804H3.46191V16.0821C3.60756 15.9805 3.77989 15.8584 3.97251 15.7185C4.58869 15.271 5.40683 14.6454 6.22184 13.9296C7.04066 13.2104 7.83568 12.4179 8.42013 11.638C9.02143 10.8356 9.31738 10.1544 9.31738 9.63973C9.31738 8.81595 9.03294 8.29181 8.67254 7.97159C8.2988 7.63952 7.77729 7.46884 7.22204 7.48666Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
});

export const CounterboreIcon = createIcon({
  displayName: 'CounterboreIcon',
  viewBox: '0 0 20 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 13.875v-5.25h-1.5v6.75h12.5v-6.75h-1.5v5.25h-9.5Z"
    />
  ),
});

export const CountersinkIcon = createIcon({
  displayName: 'CountersinkIcon',
  viewBox: '0 0 20 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.744 7.308 10 16.692l6.256-9.384h-1.803L10 13.988l-4.453-6.68H3.744Z"
    />
  ),
});

export const CylindricityIcon = createIcon({
  displayName: 'CylindricityIcon',
  viewBox: '0 0 26 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.836 5.289-.711 1.337a5.752 5.752 0 0 1 7.65 4.068l3.248-6.11 1.325.705-7.512 14.127-1.325-.704.712-1.338a5.752 5.752 0 0 1-7.65-4.068l-3.249 6.11L3 18.712l7.511-14.128 1.325.705Zm1.338 2.461a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5Z"
    />
  ),
});

export const DegreeIcon = createIcon({
  displayName: 'DegreeIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 1.5A5.75 5.75 0 1 1 9 13 5.75 5.75 0 0 1 9 1.5ZM9 3a4.25 4.25 0 1 0 0 8.5A4.25 4.25 0 0 0 9 3Z"
    />
  ),
});

export const DepthIcon = createIcon({
  displayName: 'DepthIcon',
  viewBox: '0 0 16 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.464 4.135h9.071v1.5H8.75v11.36l2.255-2.256 1.06 1.06L8 19.867 3.934 15.8l1.06-1.061 2.256 2.255V5.634H3.464v-1.5Z"
    />
  ),
});

export const DiameterIcon = createIcon({
  displayName: 'DiameterIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.726 16.213 3.47 19.47l1.06 1.06 3.257-3.256a6.75 6.75 0 0 0 9.487-9.487L20.53 4.53l-1.06-1.06-3.257 3.256a6.75 6.75 0 0 0-9.487 9.487Zm2.13-.008a5.25 5.25 0 0 0 7.349-7.349l-7.35 7.349Zm6.288-8.41-7.349 7.35a5.25 5.25 0 0 1 7.349-7.349Z"
    />
  ),
});

export const FlatnessIcon = createIcon({
  displayName: 'FlatnessIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      fill="currentColor"
      clipRule="evenodd"
      d="M7.682 5.75h14.647l-5.681 12.5H2l5.682-12.5Zm.966 1.5-4.318 9.5h11.352L20 7.25H8.648Z"
    />
  ),
});

export const FreeStateIcon = createIcon({
  displayName: 'FreeStateIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.943 7.273V16h1.317v-3.805h3.707v-1.13H10.26V8.406h4.095V7.273H8.943Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
        clipRule="evenodd"
      />
    </>
  ),
});

export const GreaterThanIcon = createIcon({
  displayName: 'GreaterThanIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 17.6532V15.9921L11.8904 12L3.5 8.00793V6.3468L15.3817 12L3.5 17.6532Z"
    />
  ),
});

export const GreaterThanOrEqualToIcon = createIcon({
  displayName: 'GreaterThanOrEqualToIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 16.355v-1.661l8.39-3.992L3 6.71V5.048l11.882 5.654L3 16.355Zm0 2.597h12v-1.5H3v1.5Z"
    />
  ),
});

export const LessThanIcon = createIcon({
  displayName: 'LessThanIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4999 17.6532V15.9921L7.10947 12L15.4999 8.00793V6.3468L3.61816 12L15.4999 17.6532Z"
    />
  ),
});

export const LessThanOrEqualToIcon = createIcon({
  displayName: 'LessThanOrEqualToIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 16.355v-1.661l-8.39-3.992L15 6.71V5.048L3.118 10.702 15 16.355Zm0 2.597H3v-1.5h12v1.5Z"
    />
  ),
});

export const EqualIcon = createIcon({
  displayName: 'EqualIcon',
  viewBox: '0 0 18 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 10.3382H3.5V8.83817H15.5V10.3382Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 15.1618H3.5V13.6618H15.5V15.1618Z"
      />
    </>
  ),
});

export const NotEqualIcon = createIcon({
  displayName: 'NotEqualIcon',
  viewBox: '0 0 18 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 10.3382H3.5V8.83817H15.5V10.3382Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 15.1618H3.5V13.6618H15.5V15.1618Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.439 17.5607L12.561 6.43934L13.6213 7.06066L6.49934 18.1821L5.439 17.5607Z"
      />
    </>
  ),
});

export const RangeIcon = createIcon({
  displayName: 'RangeIcon',
  viewBox: '0 0 18 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 7.5H6V9H4.5V18H6V19.5H4.5C3.67157 19.5 3 18.8284 3 18V9C3 8.17157 3.67157 7.5 4.5 7.5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 7.5H12V9H13.5V18H12V19.5H13.5C14.3284 19.5 15 18.8284 15 18V9C15 8.17157 14.3284 7.5 13.5 7.5Z"
      />
    </>
  ),
});

export const LeastMaterialConditionIcon = createIcon({
  displayName: 'LeastMaterialConditionIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.572 7.273V16h5.271v-1.133H10.89V7.272H9.572Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
      />
    </>
  ),
});

export const MaximumMaterialConditionIcon = createIcon({
  displayName: 'MaximumMaterialConditionIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.172 7.273H7.574V16h1.253V9.68h.08l2.575 6.307h1.04l2.573-6.302h.081V16h1.253V7.273h-1.598l-2.778 6.784h-.103L9.172 7.273Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
      />
    </>
  ),
});

export const MicroIcon = createIcon({
  displayName: 'MicroIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.75 11.551V5h-1.5v14h1.5v-4.208a4.233 4.233 0 0 0 2.75 1.01c1.176 0 2.24-.479 3.01-1.25a2.25 2.25 0 0 0 4.24-1.052v-.286h-1.5v.286a.75.75 0 0 1-1.5 0V5h-1.5v6.551a2.75 2.75 0 1 1-5.5 0Z"
    />
  ),
});

export const NoneCountIcon = createIcon({
  displayName: 'NoneCountIcon',
  viewBox: '0 0 21 20',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.215 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0-1.667a5.833 5.833 0 1 0 0-11.666 5.833 5.833 0 0 0 0 11.666Zm0-1.555c.904 0 1.743-.28 2.434-.76a.788.788 0 0 1-.096-.08L6.778 7.662a.783.783 0 0 1-.082-.096 4.278 4.278 0 0 0 3.519 6.711Zm3.438-1.94c.03.03.057.062.081.095a4.278 4.278 0 0 0-5.952-5.952.783.783 0 0 1 .096.082l5.775 5.774Z"
      clipRule="evenodd"
    />
  ),
});

export const ParallelismIcon = createIcon({
  displayName: 'ParallelismIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.074 18.771 5.244-12.98-1.39-.562-5.245 12.98 1.39.562Zm3.999 0 5.244-12.98-1.39-.562-5.245 12.98 1.39.562Z"
    />
  ),
});

export const PerpendicularityIcon = createIcon({
  displayName: 'PerpendicularityIcon',
  viewBox: '0 0 20 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.25 17.875H3v1.5h14v-1.5h-6.25V4.625h-1.5v13.25Z"
    />
  ),
});

export const PlusOrMinusIcon = createIcon({
  displayName: 'PlusOrMinusIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 4.5v4.738H3v1.5h5.25v5.012h1.5v-5.012H15v-1.5H9.75V4.5h-1.5ZM3 19.5h12V18H3v1.5Z"
    />
  ),
});

export const ProfileLineIcon = createIcon({
  displayName: 'ProfileLineIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 9.125a7.25 7.25 0 0 0-7.25 7.25h-1.5a8.75 8.75 0 1 1 17.5 0h-1.5A7.25 7.25 0 0 0 12 9.125Z"
    />
  ),
});

export const ProfileSurfaceIcon = createIcon({
  displayName: 'ProfileSurfaceIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8596 14.5C19.1575 10.7987 15.9056 8 12 8C8.09442 8 4.84251 10.7987 4.1404 14.5C4.04823 14.9859 4 15.4873 4 16H20C20 15.4873 19.9518 14.9859 19.8596 14.5ZM18.3261 14.5C17.6489 11.6333 15.0736 9.5 12 9.5C8.92642 9.5 6.3511 11.6333 5.67393 14.5H18.3261Z"
    />
  ),
});

export const ProjectedToleranceZoneIcon = createIcon({
  displayName: 'ProjectedToleranceZoneIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.12 7.273V16h1.318v-3.068h1.79c.676 0 1.237-.124 1.683-.37.449-.25.784-.589 1.005-1.015.225-.43.337-.912.337-1.449 0-.534-.11-1.014-.332-1.44a2.41 2.41 0 0 0-1.002-1.015c-.446-.247-1.008-.37-1.687-.37H9.12Zm1.318 4.542h1.67c.43 0 .777-.073 1.044-.221.267-.15.463-.355.588-.614.125-.258.188-.552.188-.882 0-.33-.063-.622-.188-.878a1.345 1.345 0 0 0-.592-.6c-.267-.146-.62-.218-1.057-.218h-1.653v3.413Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
      />
    </>
  ),
});

export const RegardlessOfFeatureSizeIcon = createIcon({
  displayName: 'RegardlessOfFeatureSizeIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.295 8.628c.33.221.517.534.562.937h1.27a2.16 2.16 0 0 0-.409-1.244 2.635 2.635 0 0 0-1.074-.857c-.451-.207-.973-.31-1.564-.31-.585 0-1.11.105-1.576.315a2.687 2.687 0 0 0-1.108.873c-.273.375-.41.814-.41 1.317 0 .608.204 1.097.61 1.466.41.37.963.65 1.662.84l1.031.28c.313.083.593.178.84.286.25.108.447.245.592.41.148.164.222.376.222.634 0 .284-.084.533-.252.746a1.66 1.66 0 0 1-.69.494c-.29.117-.62.175-.993.175-.338 0-.65-.05-.933-.15a1.658 1.658 0 0 1-.695-.464 1.35 1.35 0 0 1-.307-.788h-1.32c.028.526.177.98.447 1.364.27.38.643.674 1.12.882.478.207 1.043.31 1.697.31.681 0 1.262-.11 1.742-.331.483-.222.851-.525 1.104-.908a2.32 2.32 0 0 0 .384-1.317c0-.392-.079-.729-.235-1.01a2.207 2.207 0 0 0-.605-.707 3.436 3.436 0 0 0-.814-.46 6.5 6.5 0 0 0-.856-.277l-.853-.222a5.883 5.883 0 0 1-.532-.162 2.934 2.934 0 0 1-.52-.251 1.3 1.3 0 0 1-.388-.38.973.973 0 0 1-.145-.537c0-.247.071-.467.213-.66a1.43 1.43 0 0 1 .61-.46c.261-.114.57-.17.929-.17.5 0 .914.111 1.244.336Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
      />
    </>
  ),
});

export const StatisticalToleranceIcon = createIcon({
  displayName: 'StatisticalToleranceIcon',
  viewBox: '0 0 36 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.347 8.979c.33.221.517.534.562.937h1.27a2.16 2.16 0 0 0-.409-1.244 2.636 2.636 0 0 0-1.074-.857c-.451-.207-.973-.31-1.564-.31-.585 0-1.11.104-1.576.315a2.686 2.686 0 0 0-1.108.873c-.273.375-.41.814-.41 1.317 0 .608.204 1.097.61 1.466.409.37.963.649 1.662.84l1.031.28c.313.083.593.178.84.286.25.108.447.244.592.41.148.164.222.376.222.634 0 .284-.084.533-.252.746-.168.21-.398.375-.69.494-.29.117-.621.175-.993.175-.338 0-.65-.05-.933-.15a1.659 1.659 0 0 1-.695-.464 1.35 1.35 0 0 1-.307-.788h-1.32c.028.525.177.98.447 1.364.27.38.643.674 1.12.882.478.207 1.043.31 1.696.31.682 0 1.263-.11 1.743-.332.483-.221.851-.524 1.104-.907a2.32 2.32 0 0 0 .384-1.317c0-.392-.079-.729-.235-1.01a2.204 2.204 0 0 0-.605-.707 3.436 3.436 0 0 0-.814-.46 6.5 6.5 0 0 0-.856-.278l-.853-.221a5.873 5.873 0 0 1-.532-.162 2.931 2.931 0 0 1-.52-.252 1.3 1.3 0 0 1-.388-.379.973.973 0 0 1-.145-.537c0-.247.071-.467.213-.66a1.43 1.43 0 0 1 .61-.46c.26-.114.57-.17.928-.17.5 0 .915.111 1.245.336Zm3.095-1.355v1.133h2.718v7.594h1.313V8.757h2.723V7.624h-6.754Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.986 22 2 12 8.986 2h18.028L34 12l-6.986 10H8.986Zm17.246-1.5H9.768L3.83 12l5.938-8.5h16.464L32.17 12l-5.938 8.5Z"
      />
    </>
  ),
});

export const StraightnessIcon = createIcon({
  displayName: 'StraightnessIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12.75H4v-1.5h16v1.5Z"
    />
  ),
});

export const SurfaceFinishIcon = createIcon({
  displayName: 'SurfaceFinishIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M9.85853 15.4759L17.8575 6.23181L18.9918 7.21333L9.85853 17.7682L5.0083 12.1631L6.14259 11.1816L9.85853 15.4759Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  ),
});

export const SymmetryIcon = createIcon({
  displayName: 'SymmetryIcon',
  viewBox: '0 0 22 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 6.75h8v1.5H7v-1.5Zm-3 4.5h14v1.5H4v-1.5Zm11 4.5H7v1.5h8v-1.5Z"
    />
  ),
});

export const TangentPlaneIcon = createIcon({
  displayName: 'TangentPlaneIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62 7.273v1.133h2.719V16h1.313V8.406h2.723V7.273H8.62Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
      />
    </>
  ),
});

export const ThruIcon = createIcon({
  displayName: 'ThruIcon',
  viewBox: '0 0 40 24',
  path: (
    <path
      fill="currentColor"
      fillRule="nonzero"
      clipRule="evenodd"
      d="M3.637 8.536V7h7.237v1.536H8.176v7.276H6.334V8.536H3.637Zm8.429 7.276V7h1.863v3.636h3.782V7h1.859v8.812h-1.86v-3.64h-3.78v3.64h-1.863Zm9.039 0V7h3.477c.666 0 1.233.119 1.704.357.473.235.833.57 1.08 1.003.25.43.374.936.374 1.518 0 .586-.126 1.09-.378 1.51a2.45 2.45 0 0 1-1.098.964c-.476.224-1.052.336-1.73.336h-2.327v-1.497h2.027c.355 0 .65-.049.886-.147.235-.097.41-.243.525-.438.117-.195.176-.438.176-.728a1.45 1.45 0 0 0-.176-.74 1.081 1.081 0 0 0-.53-.456c-.235-.106-.531-.159-.89-.159h-1.256v7.289h-1.864Zm4.76-4.01 2.19 4.01h-2.057l-2.143-4.01h2.01ZM34.5 7h1.863v5.723c0 .642-.154 1.204-.46 1.686a3.08 3.08 0 0 1-1.279 1.127c-.547.267-1.186.4-1.914.4-.732 0-1.371-.133-1.92-.4a3.08 3.08 0 0 1-1.277-1.127c-.304-.482-.456-1.044-.456-1.687V7h1.863v5.563c0 .336.073.634.22.895.148.261.358.466.627.616.27.149.584.223.943.223a1.9 1.9 0 0 0 .942-.223c.27-.15.478-.355.624-.616.15-.26.224-.559.224-.895V7Z"
    />
  ),
});

export const TotalRunoutIcon = createIcon({
  displayName: 'TotalRunoutIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m18.06 4.308 2.205 3.409-1.26.815-.98-1.517-4.048 12.677H3.735l4.14-12.965-1.684.829-.663-1.346 3.865-1.902 2.205 3.409-1.26.815-.98-1.517-3.57 11.177h7.093l3.66-11.465-1.683.829-.663-1.346 3.865-1.902Z"
    />
  ),
});

export const TruePositionIcon = createIcon({
  displayName: 'TruePositionIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 22v-3.291a6.753 6.753 0 0 1-5.959-5.959H3v-1.5h2.291a6.753 6.753 0 0 1 5.959-5.959V2h1.5v3.291a6.753 6.753 0 0 1 5.959 5.959H21v1.5h-2.291a6.753 6.753 0 0 1-5.959 5.959V22h-1.5Zm5.947-10.75a5.253 5.253 0 0 0-4.447-4.447v4.447h4.447Zm-4.447 1.5h4.447a5.253 5.253 0 0 1-4.447 4.447V12.75Zm-1.5-1.5V6.803a5.253 5.253 0 0 0-4.447 4.447h4.447Zm-4.447 1.5h4.447v4.447a5.253 5.253 0 0 1-4.447-4.447Z"
    />
  ),
});

export const UnequallyDisposedToleranceIcon = createIcon({
  displayName: 'UnequallyDisposedToleranceIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.468 7.273h-1.32v5.633c0 .395-.088.746-.26 1.053a1.823 1.823 0 0 1-.742.724c-.321.174-.703.26-1.147.26-.44 0-.82-.086-1.142-.26a1.887 1.887 0 0 1-.745-.724 2.103 2.103 0 0 1-.26-1.053V7.273H8.535v5.74c0 .61.143 1.152.43 1.623a3 3 0 0 0 1.21 1.108c.52.267 1.128.4 1.824.4.7 0 1.309-.133 1.829-.4.52-.27.923-.639 1.21-1.108.287-.471.43-1.012.43-1.623v-5.74Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
      />
    </>
  ),
});
